export default __webpack_public_path__ + "static/media/Rastech-update-3.c1288fb3.jpg";